import React from "react";
import HtmlHead from "../components/html-head/HtmlHead";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setIsOpenRightMenu } from "../store/reducers/menuReducer";
import RightMenu from "./components/RightMenu";
import Header from "../components/layaut/Header";

export default function Page_404() {

	const dispatch = useDispatch();
	const title = "404";
	const description = "";

	return (
		<div className="home page-404">
			<HtmlHead title={title} description={description} />
			<RightMenu>
				<div>
					<Link
						to="/"
						className="link"
						onClick={() => {
							dispatch(setIsOpenRightMenu(false));
						}}
					>
						главная
					</Link>
					<Link
						to="/?id=courses"
						className="link"
						onClick={() => {
							dispatch(setIsOpenRightMenu(false));
						}}
					>
						курсы
					</Link>
					<Link
						to="/?id=about"
						className="link"
						onClick={() => {
							dispatch(setIsOpenRightMenu(false));
						}}
					>
						обо мне
					</Link>
				</div>
			</RightMenu>

			<Header>
				<div className="w-100 d-flex">
					<div className="d-flex justify-content-center w-100 gap-3">
						<Link to="/" className={`header-button text-nowrap px-40`}>
							главная
						</Link>
						<Link to="/?id=courses" className={`header-button text-nowrap px-40`}>
							курсы
						</Link>
						<Link to="/?id=about" className={`header-button text-nowrap px-40`}>
							обо мне
						</Link>
					</div>
				</div>
			</Header>

			<div className="d-flex flex-column align-items-center px-4">
				<div className="title text-center">ОШИБКА 404</div>
				<div className="description mb-4 text-center">Мы хорошо искали, но такой страницы точно нет...</div>
				<div className="mb-5">
					<div className="cat">
						<img src="/gif/home.gif" />
					</div>
				</div>
			</div>
		</div>
	)
}




